import style from "./error-screen.css";

export default function ErrorScreen({ title, message}) {
  return <div id={style["error-screen"]}>
    <img id={style.logo} src={"https://epistlesubscribe.epistle.org/assets/images/logo.png"} alt=""/>
    <h1 id={style.title}>{title}</h1>
    <p id={style.description}>{message}</p>
  </div>

}